import { m } from 'framer-motion';
import { Stack, Dialog } from '@mui/material';

import { Strings } from '@app/constants';
import { Header } from '@app/sections/header';
import { Scrollbar, varBounce } from '@app/components';
import { getFileType } from '@app/configs';
import { PageNotFoundIllustration } from '@app/assets/illustrations';

interface Props {
  open: boolean;
  onClose: VoidFunction;
  resume?: string;
  images?: any;
  titleName?: string;
}

const AttachmentViewer = ({ open, onClose, resume, images, titleName }: Props) => {
  const filetype = getFileType(resume ?? '');
  const hasData = Boolean((images && images?.length > 0) || resume);

  const isVideoFile = (url: string) => {
    const videoExtensions = ['mp4', 'webm', 'ogg', 'mov'];
    const extension = url?.split('.')?.pop()?.toLowerCase();
    return extension ? videoExtensions.includes(extension) : false;
  };

  return (
    <Dialog open={open} fullWidth>
      <Header variant="dialog" title={titleName ?? Strings.field.attachment} onClose={onClose} />
      <Scrollbar>
        {!hasData ? (
          <m.div variants={varBounce().in}>
            <PageNotFoundIllustration
              sx={{
                height: 260,
                my: { xs: 3, sm: 10, md: 5 },
              }}
            />
          </m.div>
        ) : (
          <Stack
            sx={{
              gap: 2,
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'space-around',
              flexDirection: { xs: 'column', sm: 'row' },
            }}
          >
            {images && images.length > 0 ? (
              images.map((image: any, index: any) => (
                <Stack key={index} width={{ sm: '90%', md: '100%' }} p={1}>
                  {isVideoFile(image?.attachment) ? (
                    <video
                      src={image?.attachment}
                      controls
                      style={{
                        width: '100%',
                        height: '50px',
                        objectFit: 'contain',
                      }}
                    />
                  ) : (
                    <embed
                      src={image?.attachment}
                      style={{
                        width: '100%',
                        height: '450px',
                        objectFit: 'contain',
                      }}
                    />
                  )}
                </Stack>
              ))
            ) : (
              <Stack width={{ sm: '90%', md: '100%' }} p={1}>
                {filetype === 'word' && resume ? (
                  <iframe
                    className="pdf"
                    width="100%"
                    height="600"
                    src={`https://docs.google.com/gview?url=${encodeURIComponent(
                      resume
                    )}&embedded=true`}
                  ></iframe>
                ) : isVideoFile(resume ?? '') ? (
                  <video
                    src={resume}
                    controls
                    style={{
                      width: '100%',
                      height: '450px',
                      objectFit: 'contain',
                    }}
                  />
                ) : (
                  <embed
                    src={resume}
                    style={{
                      width: '100%',
                      height: '450px',
                      objectFit: 'contain',
                    }}
                  />
                )}
              </Stack>
            )}
          </Stack>
        )}
      </Scrollbar>
    </Dialog>
  );
};

export { AttachmentViewer };
